import * as React from "react";

const SvgHeavySnowSun = (props) => (
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySnowSun_svg__a">
        <path d="M766.19 404.905c0-7.16 5.803-12.963 12.962-12.963 7.16 0 12.964 5.803 12.964 12.963 0 7.159-5.804 12.963-12.964 12.963-7.159 0-12.962-5.804-12.962-12.963" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySnowSun_svg__b">
        <path d="M0 943.388h1828.656V0H0Z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySnowSun_svg__c">
        <path d="M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 0 1-9.662 0" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySnowSun_svg__d">
        <path d="M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySnowSun_svg__e">
        <path d="M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-9.662 0" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySnowSun_svg__f">
        <path d="M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-9.662 0" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySnowSun_svg__g">
        <path d="M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-9.662 0" />
      </clipPath>
    </defs>
    <g
      clipPath="url(#HeavySnowSun_svg__a)"
      transform="matrix(1.33333 0 0 -1.33333 -970.237 565.474)"
      style={{
        fill: "#ffc824",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#ffc824",
          fillOpacity: 1,
        }}
      >
        <path
          d="M766.19 404.905c0-7.16 5.803-12.963 12.962-12.963 7.16 0 12.964 5.803 12.964 12.963 0 7.159-5.804 12.963-12.964 12.963-7.159 0-12.962-5.804-12.962-12.963"
          style={{
            fill: "#ffc824",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#HeavySnowSun_svg__b)"
      style={{
        fill: "#647179",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -560.176 561.515)"
    >
      <g
        style={{
          fill: "#647179",
          fillOpacity: 1,
        }}
      >
        <path
          d="M0 0c5.89 0 10.664 4.774 10.664 10.664S5.89 21.328 0 21.328c-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085.001-.168.006-.253.006-7.289 0-13.198-5.91-13.198-13.199S-40.094 0-32.805 0"
          style={{
            fill: "#647179",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none",
          }}
          transform="translate(473.696 377.985)"
        />
      </g>
    </g>
    <g
      clipPath="url(#HeavySnowSun_svg__c)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -554.32 567.737)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 0 1-9.662 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#HeavySnowSun_svg__d)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -578.538 553.737)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#HeavySnowSun_svg__e)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -583.571 544.42)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-9.662 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#HeavySnowSun_svg__f)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -549.571 558.42)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-9.662 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#HeavySnowSun_svg__g)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -538.571 544.42)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-9.662 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <path
      style={{
        opacity: 0.996721,
        fill: "none",
        stroke: "none",
        strokeWidth: 0.878738,
        strokeLinejoin: "round",
        paintOrder: "stroke fill markers",
      }}
      transform="matrix(1.33333 0 0 1.33333 736 -70.15)"
      d="M-552 52.612h72v72h-72z"
    />
  </svg>
);

export default SvgHeavySnowSun;
